// A DUMB FORM: NOTHING ON OUR SIDE REFUSES A PAY PRESS (31 Oct 2026).
//
// Robin, 31 Oct 2026: "just have a dumb form with fields, only validation is
// car reg which is external.. they book and an issue with the because aider
// follows up and requests the details, so aider checks and confirms and does
// nothing or follows up for missing fiels", and "im fucking sick and tired of
// blocking bookings because of validations, enough". Then, on the lookups:
// "but thats an autocomplete, we dont validate for fields at pay, if customer
// is willing to pay we let them and aider resolves missing info..".
//
// WHAT WAS THERE BEFORE. The pay press ran `payProblems` over the
// registration, the car location and the mobile, triggered react-hook-form's
// `required` rules on the car size, the day and the time, refused the press,
// painted red on the fields and asked again in a panel at the buttons. Since
// 5 Oct 2026, customers only: 23 `validation_blocked` over 13 sessions;
// `details_incomplete` 22 presses over 11 people, `carSize` 19 over 9, `date`
// 13 over 6, `mobile` 12 over 5, and exactly ONE on an incomplete card.
// Every refused session's FIRST press was refused, two of them 26 and 22
// times. Four rounds of making the refusal kinder never removed it.
//
// Note the number nobody should spin: 13 people were refused at least once
// and 3 of them paid (23.1%), against 6.5% for the 168 who were never
// refused. A refusal marks a SERIOUS buyer. The case for deleting it is the
// experience and the handful of serious buyers we did not close, not a
// conversion gap.
//
// WHERE THE DEFAULTS LIVE, AND WHY NOT HERE. Every answer the form used to
// demand has one (the smallest car size, the earliest day, Anytime), and
// THE SERVER APPLIES ALL OF THEM: `Order#fill_booking_defaults`. That is
// deliberate and this file is where the reason is written down.
//
// A default has to be TOLD APART from a customer's own answer, because Aider
// asks about one and not the other (`Order#missing_details`
// :car_size_assumed, :date_assumed, off `orders.car_size_assumed` and
// `orders.date_assumed`). If the form filled the boxes in before posting,
// the order would arrive indistinguishable from one where the customer chose
// the same values, the flags could never be stamped honestly, and Aider
// would either confirm a size on every booking or on none. So the form sends
// the gaps as gaps, and the one place that fills them is the one place that
// records having filled them.
//
// What the form still does about a default is SAY SO, once, where it moves
// the price (ASSUMED_SIZE_LINE below): a price surprise at the door is the
// one thing a default must not create. The amount on screen is already the
// smallest-size price, because the large surcharge is only ever added by a
// size that was actually chosen, so the total the customer presses on is the
// total the server charges.
//
// WHAT STILL STOPS A CUSTOMER: Stripe's own card fields, and nothing else.
// The registration lookup and the address picker stay, as autocomplete: the
// plate fills the make, model and size, the picker helps someone type where
// the car is. Neither gates anything, and neither does the server's
// postcodes.io check (it flags `postcode_not_found` for support, as it has
// since 9 Oct 2026, and refuses nothing).
//
// Pure, so it runs under node --test (pay-defaults.test.mjs). No em dashes.
import { fields } from '../store/constants/fields.js'
import { dayState, isOff } from './availability.js'

// The one line the form says about a default, because this default moves the
// price. Non-blocking, not an error: it sits by the two size buttons, which
// are already on screen whenever the plate gave no size.
//
// Our terms and the FAQ already promise what it promises ("your operator may
// discuss any additional or alternative services ... agreed with you before
// any additional work is carried out"), so it states the existing deal
// rather than inventing one.
export const ASSUMED_SIZE_LINE = 'Smallest size assumed. Your operator will confirm at the car.'

// Does the form hold a size the customer or the plate actually chose?
// `sizeSource` is lib/vehicle.js SIZE_SOURCE: 'lookup' (the plate's car, and
// "Large from the plate is applied, never a surprise" still holds), 'manual'
// or 'changed' (the customer picked). Anything else and the size on the order
// will be the server's assumption, which is what ASSUMED_SIZE_LINE says out
// loud and what `orders.car_size_assumed` records.
export const sizeWasChosen = (values = {}, sizeSource = null) =>
  !!values[fields.carSize] && ['lookup', 'manual', 'changed'].includes(sizeSource)

// WHAT THE PRESS MAY STILL FILL IN ITSELF: the time slot, and only the time
// slot. TimeSlots preselects Anytime on screen, so this is the belt for a
// draft restored without one; it is not a default anybody needs told about,
// because it is what the form was already showing.
//
// Returns the patches to apply, as [{ name, value }], and NEVER a reason to
// stop. There is no code path in this module that can refuse a press.
export const payDefaults = ({ values = {}, anytime = null } = {}) =>
  (!values[fields.timeSlot] && anytime ? [{ name: fields.timeSlot, value: anytime }] : [])

// THE DAY IS DEFAULTED ON SCREEN, NOT AT THE PRESS, and that is the
// difference between an honest default and a silent one (31 Oct 2026).
//
// Robin's ruling is "date the earliest available", which supersedes 9 Oct's
// "no default day" (short notice stresses operations). The first build of it
// left the day empty and let the server fill it, so a customer could pay
// without ever seeing which day they had bought; and `prepareOrderParams`
// formats the date into the request, so an empty one was the last thing on
// the pay path that could still refuse a willing payer. Both are fixed by
// the same move: the form picks the earliest day, SHOWS it as chosen, and
// tells the server it was our choice (orders.date_assumed), so Aider
// confirms it and the customer can change it with one tap first.
//
// NEVER TODAY, even while the same-day window is open: today carries the
// same-day surcharge and a default must not put a charge on a booking
// nobody saw. Tomorrow is the earliest day we will choose for somebody.
// `days` is the district's availability (lib/availability.js), so a day
// operations has closed is skipped rather than booked. Null when there is no
// day to offer, and then nothing is set and the server fills it.
export const firstAvailableDay = (chips = [], days = null) =>
  (chips.find(chip => !chip.isToday && !isOff(dayState(days, chip.date))) || null)?.date || null
